import ReactGA from "react-ga4";

export const initGA = (trackingId: string) => {
  ReactGA.initialize(trackingId, {
    gaOptions: {
      cookieFlags: 'SameSite=None;Secure', // Asegura compatibilidad con el futuro bloqueo de cookies de terceros
    }
  });
}

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
}

export const logPageViewPath = (path: string) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
